module.exports = __webpack_public_path__ + "static/media/hanger.3e959cd7.svg";